<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <g clip-path="url(#a)">
    <path fill-rule="evenodd" d="M13.166 2.975a2 2 0 0 0-2.332 0l-7.07 5.07a2 2 0 0 0 0 3.251l7.07 5.071a2 2 0 0 0 2.332 0l7.07-5.07a2 2 0 0 0 0-3.251l-7.07-5.071ZM19.07 9.67 12 4.6 4.929 9.671 12 14.742l7.071-5.071Z" clip-rule="evenodd"/>
    <path d="M2.965 14.352A2 2 0 0 1 3.33 13.2L12 19.418l8.67-6.218a2 2 0 0 1-.469 2.777l-7.035 5.046a2 2 0 0 1-2.332 0L3.8 15.977a2 2 0 0 1-.834-1.625Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h24v24H0z"/>
    </clipPath>
  </defs>
</svg>
